// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"698d538f","453":"88a524d8","547":"bbf616a8","549":"c8304f21"}[chunkId] + ".chunk.js";
};